import { useEffect, useState } from 'react';
import Login from '../features/authentication/Login';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

import type { FC, ReactNode } from 'react';

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  // MFA対応 start --------------
  // MFA必須のユーザーがMFA未認証の場合 (※ID/Passwordによる1次認証済み)
  useEffect(() => {
    const executeLogout = async () => {
      await auth.logout();
    };
    // MFA必須のユーザーがMFA未認証の場合、1次認証時にログイン済みなので、ログアウトしてログイン画面へ遷移させる
    if (auth.isRequiredMfa && !auth.isMfaAuthenticated) {
      executeLogout();
    }
  }, [auth.isRequiredMfa, auth.isMfaAuthenticated]);

  // ログイン未完了の場合
  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }
  // MFA対応 end ----------------

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
